export default (rangeSelectorRef) => {
    var _a;
    const element = (_a = rangeSelectorRef.current) === null || _a === void 0 ? void 0 : _a.instance.element();
    const leftTracker = element === null || element === void 0 ? void 0 : element.querySelector(".dxrs-trackers > .slider-tracker:not(:last-child)");
    const rightTracker = element === null || element === void 0 ? void 0 : element.querySelector(".dxrs-trackers > .slider-tracker:last-child");
    return { leftTracker, rightTracker };
};
